class Locale {
  constructor(code, messages) {
    this.code = code
    this.messages = messages
  }
}
export default Locale
